<script setup></script>

<template>
  <div class="tit-exp">*생년월일시와 옵션을 활용해서 사주팔자를 확인해보세요.</div>
</template>
